import { atom, RecoilState } from 'recoil'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
export const intercomErrorState: RecoilState<string | null> = atom({
  key: 'intercom_error',
  default: null,
})
